import { deepSetData, deepGetData } from "../../utility";

const subreddit = {
	initial: {
		threads: [],
		subreddit: null,
		sortBy: 'hot'
	},
	saveSubreddit: ({ threads, subreddit }) => (dispatch, getState) => {
		let nextState = deepSetData(getState())('subreddit')({
			threads,
			subreddit
		});

		dispatch({
			type:"DATA/SUBREDDIT/saveSubreddit",
			nextState,
			action: {
				threads,
				subreddit
			}
		})	
	},
	appendSubreddit: ({ threads, subreddit }) => (dispatch, getState) => {
		const { threads: oldThreads, subreddit:oldSubreddit } = deepGetData(getState())('subreddit');

		//if subreddit has been changed in loading time exit
		if(oldSubreddit !== subreddit) { return; }

		const freshThreads = threads.filter( thread => !oldThreads.some( oldThread => oldThread.linkId === thread.linkId ) );
		const newSubreddit = oldThreads.concat(freshThreads);

		const nextState = deepSetData(getState())('subreddit')({
			threads: newSubreddit
		})

		dispatch({
			type: "DATA/SUBREDDIT/appendSubreddit",
			nextState,
			action: {
				threads,
				subreddit
			}
		})
	},
	changeSortBy: newSortBy => (dispatch, getState) => {
		const nextState = deepSetData(getState())('subreddit')({
			sortBy: newSortBy
		})

		dispatch({
			type: "DATA/SUBREDDIT/changeSortBy",
			nextState,
			action: {
				newSortBy
			}
		})
	}
}

export default subreddit;